import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Carousel from '../../components/Carousel';
import styles from './Solutions.module.scss';
import ProductHighlight from '../../components/ProductHighlight';
import { Icon } from '@src/components/ui';
const Solutions = () => {
    return (_jsxs("main", { className: styles.home, children: [_jsx("section", { className: styles.hero, children: _jsxs("div", { className: styles.heroContent, children: [_jsx("h1", { children: "Solutions" }), _jsx("p", { children: "Solutions" }), _jsx(Icon, { faIconName: 'faShoppingCart' })] }) }), _jsx("section", { className: styles.carousel, children: _jsx(Carousel, { items: [
                        {
                            title: 'Orthopedic Support',
                            description: 'Joints, tendons, ligaments',
                        },
                        {
                            title: 'Wound & Tissue Healing',
                            description: 'Surgical recover, skin repair',
                        },
                        {
                            title: 'Pain Management',
                            description: 'Chronic pain, inflammation',
                        },
                        {
                            title: 'Neurological Support',
                            description: 'Nerve regeneration, mobility',
                        },
                        {
                            title: 'Dental & Oral Health',
                            description: 'Jaw, tooth, or gum treatment',
                        },
                        {
                            title: 'General Wellness',
                            description: 'Immune support, preventive care',
                        },
                    ] }) }), _jsx("section", { className: styles.productHighlight, children: _jsx(ProductHighlight, {}) })] }));
};
export default Solutions;
